module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-data-backoffice":"BO Mitarbeiter","fullname-label":"Name","email-label":"E-Mail"},"fr":{"email-label":"E-mail","fullname-label":"Nom","title-data-backoffice":"Employés du BO"},"it":{"email-label":"E-mail","fullname-label":"Cognome","title-data-backoffice":"Collaboratore BO"}}')
  delete Component.options._Ctor
}
